<template>
<w-sliding-popup ref="slidingPopup" title="장비 일괄 적용" width="1250px" @close="close()">
  <div slot="content">
    <el-row type="flex" justify="space-between" :gutter="15">
      <el-col :span="13">
        <el-row class="title-bar" type="flex" justify="space-between">
          <div class="vertical-center-box">
            <div class="title-h3 mr-r15">선택된 장비 목록</div>
          </div>
          <div class="vertical-center-box" align="right">
            <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
          </div>
        </el-row>
        <el-table-wrapper ref="jobTable" :column-default="columnDefault" :data="tableData.node" :columns="tableColumns.node" :show-search-tool="showSearchTool"
        :show-custom-header="true" pagination :total="total.node">
        </el-table-wrapper>
      </el-col>
      <el-col :span="11">
        <el-row class="title-bar" type="flex" justify="space-between">
          <div class="vertical-center-box">
            <div class="title-h3 mr-r15">작업 목록</div>
          </div>
          <div class="vertical-center-box" align="right">
            <w-header-search-button @click="showNodeSearchTool = !showNodeSearchTool"></w-header-search-button>
          </div>
        </el-row>
        <el-table-wrapper ref="nodeTable" :column-default="columnDefault" :data="tableData.job" :columns="tableColumns.job" :show-search-tool="showNodeSearchTool"
        :show-custom-header="true" pagination :total="total.job" @selection-change="onSelectionChange">
        </el-table-wrapper>
      </el-col>
    </el-row>
  </div>
  <div slot="footer">
    <el-button size="large" :disabled="!isAllApply" type="primary" @click="onClickApplyButton">일괄적용</el-button>
    <el-button size="large" @click="close">취소</el-button>
  </div>
</w-sliding-popup>
</template>

<script>
import { isNil, uniqWith } from 'lodash';
import { getValueAfterCheckEmpty, EMPTY_TEXT } from '@/utils/string';
import msgUtil from '@/utils/message';
import { columnDefault } from '@/constants/table';
import AmsExecutionAPI from '@/api/ams/execution';
// import WExecutionResultBufferPopup from './ExecutionResultBufferPopup';
import WTriggerNodeSettingPopup from './TriggerNodeSettingPopup';

const defaultFormatter = (row, column, value) => getValueAfterCheckEmpty(value);

export default {
  name: 'WTriggerNodeApplicationPopup',
  components: {
    // WExecutionResultBufferPopup,
    WTriggerNodeSettingPopup,
  },
  props: {
    selectedTrigger: {
      type: Object,
      default: () => null,
    },
    tableData: {
      type: Object,
      default() {
        return {
          node: [],
          job: [],
        };
      },
    },
  },
  computed: {
    title() {
      let title = EMPTY_TEXT;
      if (!isNil(this.selectedTrigger)) {
        title = `[${this.selectedTrigger.triggerName}] 수행`;
      }
      return title;
    },
    nodeTitle() {
      let title = '장비 목록';
      if (!isNil(this.selectedJob)) {
        title = `[${this.selectedJob.jobName}] 장비 목록`;
      }
      return title;
    },
    isAllApply() {
      return this.checkedRows.length > 0;
    },
  },
  data() {
    return {
      selectedJob: null,
      columnDefault,
      total: {
        job: 0,
        node: 0,
      },
      showSearchTool: false,
      showNodeSearchTool: false,
      tableColumns: {
        job: [
          {
            align: 'center',
            type: 'selection',
          },
          {
            prop: 'grpName',
            label: '그룹이름',
            searchable: true,
            formatter: defaultFormatter,
          },
          {
            prop: 'jobName',
            label: '작업이름',
            searchable: true,
            formatter: defaultFormatter,
          },
          {
            prop: 'failover',
            label: '실패제어',
            searchable: true,
            formatter: defaultFormatter,
            width: '100px',
          },
        ],
        node: [
          {
            prop: 'nodeIp',
            label: '장비IP',
            searchable: true,
            formatter: defaultFormatter,
          },
          {
            prop: 'nodeName',
            label: '장비이름',
            searchable: true,
            formatter: defaultFormatter,
          },
        ],
      },
      triggerNodeList: [],
      checkedRows: [],
    };
  },
  methods: {
    open() {
      this.$refs.slidingPopup.visible = true;
    },
    close() {
      this.$refs.slidingPopup.visible = false;
    },
    resetData() {
      this.total.job = 0;
      this.tableData.job = [];
      this.total.node = 0;
      this.tableData.node = [];
      this.selectedJob = null;
    },
    onSelectionChange(selection) {
      this.checkedRows = selection;
    },
    onClickApplyButton() {
      const nodeList = this.tableData.node;
      const jobList = this.checkedRows;
      const triggerNodeList = [];
      const triggerJobList = [];
      jobList.forEach((job) => {
        nodeList.forEach((node) => {
          triggerNodeList.push({
            triggerId: job.triggerId,
            jobId: job.jobId,
            nodeId: node.nodeId,
          });
          triggerJobList.push({
            triggerId: job.triggerId,
            jobId: job.jobId,
            triggerExecTypeId: 'DIRECT',
          });
        });
      });
      const params = {
        triggerNodeList,
        triggerJobList: uniqWith(triggerJobList),
      };
      AmsExecutionAPI.applyTriggerNode(params)
        .then((response) => {
          if (response.data.success) {
            this.$message(msgUtil.getResultMsgData('장비', '일괄적용', true));
            this.close();
          } else {
            this.$message(msgUtil.getResultMsgData('장비', '일괄적용', false));
          }
        })
        .catch((e) => {
          this.$message(msgUtil.getResultMsgData('장비', '일괄적용', false));
          throw e;
        });
      // 템플릿 수행 task 시작
      // this.$confirm(...msgUtil.getCustomConfirmData('템플릿을 수행하시겠습니까?')).then(() => {
      //   AmsExecutionAPI.executeDirectTrigger({
      //     triggerId: this.selectedTrigger.triggerId,
      //   })
      //     .then((response) => {
      //       if (response.data.success) {
      //         const triggerExecId = response.data.data;
      //         this.$store.dispatch('executeTriggerTask', triggerExecId);
      //         this.$message(msgUtil.getCustomResultMsgData('템플릿을 수행합니다. 대량 장비에 대해 템플릿을 수행할 경우 시간이 다소 소요될 수 있습니다.', true));
      //         this.close();
      //       } else {
      //         this.$message(msgUtil.getResultMsgData('수행', '템플릿', false));
      //       }
      //     })
      //     .catch((e) => {
      //       this.$message(msgUtil.getResultMsgData('수행', '템플릿', false));
      //       throw e;
      //     });
      // });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/work/popup/components/ExecuteTrigger/popup/TriggerNodeApplicationPopup.vue